import React, { useEffect, useState } from "react";
import { XCircleIcon } from "@heroicons/react/solid";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import { useSelector, connect } from "react-redux";

import {
  listGetAllTags,
  listAddUsersToTag,
} from "../../../redux/actions/nrp/listActions";
import { Modal } from "../../components";

// get step data from redux main state
const data = (state) => state.nrpList;

const CustomListModal = (props) => {
  const [selectedLabel, setSelectedLabel] = useState("");
  const [newLabel] = useState("");
  const [allLabels, setAllLabels] = useState([]);
  let { tagsList } = useSelector(data);

  let { customListModal, onBackdropClick, handelNo, handelCustomStatusData } =
    props;

  let getActiveTagData = (e) => {
    let activeTag = e.target.value;
    handelCustomStatusData(
      null,
      [
        {
          columnName: "tagId",
          columnType: "tagId",
          value: activeTag,
        },
      ],
      true
    );
    setSelectedLabel(activeTag);
    handelNo();
  };

  useEffect(() => {
    if (allLabels.length === 0 && newLabel.length === 0) {
      props.listGetAllTags(props.campaign);
    }
  }, []);
  useEffect(() => {
    if (tagsList) {
      setAllLabels(tagsList);
    }
  }, [tagsList]);
  return (
    <Modal
      classCustom="2xl:w-[20%] xl:w-[20%] lg:w-[25%] md:w-[45%] w-[50%]"
      open={customListModal}
      onBackdropClick={onBackdropClick}
    >
      <div className="bg-white  border-3 border-[#FEBB13]">
        <div className="bg-[#007E8C] px-2 py-4 flex flow-row justify-between">
          <h3></h3>
          <h3 className="text-[#FFFFFF] ml-4 font-semibold text-lg">
            Custom Lists
          </h3>
          <XCircleIcon
            onClick={handelNo}
            className="w-7 h-7 cursor-pointer "
            color="white"
          />
        </div>
        <div className="px-10 my-6">
          <div className="flex justify-center items-center mt-6">
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={selectedLabel}
              onChange={getActiveTagData}
            >
              {allLabels &&
                allLabels.map((item, i) => {
                  return (
                    <div key={i} className="flex  flex-col ">
                      {item.name === "Top Candidates" ? null : (
                        <FormControlLabel
                          onChange={(e) => getActiveTagData(e, item)}
                          value={item.id}
                          control={
                            <Radio
                              checked={selectedLabel === item.id ? true : false}
                            />
                          }
                          label={
                            <div className="flex flex-row items-center">
                              <p className="mx-4">{item.name}</p>
                            </div>
                          }
                        />
                      )}
                    </div>
                  );
                })}
            </RadioGroup>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  listGetAllTags,
  listAddUsersToTag,
})(CustomListModal);
